import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgDuurzaamheid = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.6892 1.94727L20.4864 3.16432C20.3806 3.79915 20.322 4.58995 20.2515 5.54113L20.2316 5.80871C20.1534 6.85705 20.0572 8.04918 19.8628 9.28088C19.475 11.7368 18.6821 14.4532 16.7526 16.6584C14.2223 19.5502 11.7609 20.4095 9.46218 19.9534C7.94078 19.6515 6.62505 18.7907 5.5428 17.8713L4.20711 19.207L2.79289 17.7928L4.08936 16.4963C1.42586 13.6417 0.937705 9.148 4.2929 5.79281C5.04845 5.03726 6.18007 4.46815 7.39642 4.02451C8.63562 3.57254 10.0692 3.21364 11.5214 2.93085C14.4264 2.36515 17.5023 2.08583 19.4566 2.00086L20.6892 1.94727ZM8.08171 5.90344C6.95327 6.31502 6.15156 6.76257 5.70711 7.20702C3.22299 9.69114 3.52594 12.9317 5.5173 15.095L16.8379 4.19372C15.3096 4.34144 13.573 4.56891 11.9036 4.89398C10.51 5.16536 9.1873 5.50021 8.08171 5.90344ZM18.2401 5.61995L6.97889 16.4641C7.8745 17.2043 8.83031 17.789 9.85142 17.9916C11.2406 18.2673 13.0292 17.8766 15.2474 15.3414C16.8179 13.5466 17.525 11.263 17.8872 8.96895C18.0678 7.82565 18.1591 6.70529 18.2372 5.65987L18.2401 5.61995Z"
      fill="currentColor"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgDuurzaamheid);

export default ForwardRef;
